export default function resolveDefaultRegion(pathname: string) {
    if (/(^|\/)azure(\/|$)/.test(pathname)) return "us-east";
    if (/(^|\/)gcp(\/|$)/.test(pathname)) return "us-east4";
    return "us-east-1";
}
